import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { patientsService } from '../../services/patient';
import { handlers } from './../../helpers/helpers';
import statusDictionary from '../../helpers/statusDictionary.json';

const useGetSurveyData = ({ surveys, countryCode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [surveyData, setSurveyData] = useState();
  const [startedSurvey, setStartedSurvey] = useState(false);
  const [questionFromSummary, setQuestionFromSummary] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const goBack = useCallback(() => {
    localStorage.removeItem('surveyData');
    navigate(`/mis-examenes/${countryCode}`);
  }, [navigate, countryCode]);

  useEffect(() => {
    if (startedSurvey) {
      surveys.setSurveyData(surveyData);
    }

    if (questionFromSummary) {
      surveys.setQuestionFromSummary(questionFromSummary);
    }
  }, [startedSurvey, surveys, surveyData, questionFromSummary])

  const setOccupied = useCallback(() => {
    const surveyData = JSON.parse(localStorage.getItem('surveyData'));
    if (surveyData) {
      setLoading(true);

      patientsService.setAdmissionPatientExamState({
        admission_patient_exam_id: surveyData.admission_patient_exam_id,
        exam_code: surveyData.exam_code,
        state: statusDictionary.occupied.status,
      }).then(response => {
        if (response !== undefined) {
          surveyData.is_started = true;
          setStartedSurvey(true);
          handlers.handleSurveyData(surveyData);
        }
      }).catch(error => {
        setError(error);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    setStartedSurvey(false);
    setLoading(false);
    setSurveyData();
    setError(null);
    setQuestionFromSummary();

    const data = JSON.parse(localStorage.getItem('surveyData'));
    const questionToEdit = JSON.parse(localStorage.getItem('questionToEdit'));

    if (data) {
      if (data.is_summary_started && !questionToEdit) {
        navigate(`/mis-examenes/${countryCode}/encuesta-salud/sumario`)
      } else {
        setSurveyData(data.surveys);
        if (data.is_started) {
          setStartedSurvey(true);
        }

        if (questionToEdit) {
          setQuestionFromSummary(questionToEdit);
        }
      }
    } else {
      navigate(`/mis-examenes/${countryCode}`);
    }

  }, [location, navigate, countryCode]);

  return { surveyData, error, loading, setSurveyData, startedSurvey, setStartedSurvey, setOccupied, goBack };
}

export default useGetSurveyData;
